import { render, staticRenderFns } from "./PollRankedEditor.vue?vue&type=template&id=791d66df&scoped=true"
import script from "./PollRankedEditor.vue?vue&type=script&lang=js"
export * from "./PollRankedEditor.vue?vue&type=script&lang=js"
import style0 from "./PollRankedEditor.vue?vue&type=style&index=0&id=791d66df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d66df",
  null
  
)

export default component.exports